<template>
  <div :class="['ibox', 'analytics-dashboard-content-box', {'analytics-dashboard-content-notitle': !title}, {'dashboard-content-embedded': embedded}]" :style="contentBoxStyles">
    <div class="ibox-title" v-if="title">
      <slot name="title" />
      <router-link class="link" :to="link" v-if="link">{{linkName}}</router-link>
      <h5>{{title}}</h5>
      <h5 class="sub-title">
        {{subTitle}}
        <slot name="subtitle" />
      </h5>
    </div>
    <div :class="['ibox-content', 'p-0', scrollable ? 'scrollable' : '']">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.analytics-dashboard-content-box .ibox-content.scrollable {
  overflow-y: scroll;
}
</style>

<script>
export default {
  name: 'DashboardContentBox',
  props: {
    title: String,
    subTitle: String,
    link: String,
    linkName: String,
    gridWidth: Number,
    gridHeight: Number,
    embedded: Boolean,
    scrollable: Boolean
  },
  computed: {
    contentBoxStyles() {
      var styles = {}

      if(this.gridWidth) {
        styles.width = this.gridWidth + 'px'
        styles['max-width'] = this.gridHeight + 'px'
      }
      if(this.gridHeight) {
        styles.height = this.gridHeight + 'px'
        styles['max-height'] = this.gridHeight + 'px'
      }

      return styles
    }
  }
}
</script>